import {
  isDwbTrainingCourseCode,
  K8_TRAINING_COURSE_CODES,
} from 'utils/program/training'
import { isTrainingArticleRoute } from 'utils/routing/routeHelpers'
import {
  getRegistrationFromInstructorScope,
  matchesRegistrationCourseCode,
  findEducatorRegistrationByCourseCode,
} from 'utils/registrationHelpers'

export const PROGRAM_TRAINING_LESSON_TYPE = 'trainingProgram'
export const SCHOOLWIDE_TRAINING_LESSON_TYPE = 'schoolwideTraining'
export const CURRICULUM_TRAINING_LESSON_TYPE = 'trainingCurriculum'

export const TRAINING_LESSON_TYPES = new Set([
  PROGRAM_TRAINING_LESSON_TYPE,
  CURRICULUM_TRAINING_LESSON_TYPE,
  SCHOOLWIDE_TRAINING_LESSON_TYPE,
])

export const isTrainingLessonType = (lessonType, courseCode) => {
  if (TRAINING_LESSON_TYPES.has(lessonType)) return true
  return K8_TRAINING_COURSE_CODES.has(String(courseCode || ''))
}

export const isTrainingMarkCompleteContext = (lessonType, courseCode) => {
  return (
    isTrainingLessonType(lessonType, courseCode) || isTrainingArticleRoute()
  )
}

/**
 * Resolves which registration id to send to the attempts endpoint.
 */
export const resolveRegistrationId = ({
  instructorData,
  registrations,
  classId,
  courseCode,
  instructorDataKey,
  lessonType,
}) => {
  if (!instructorData) return null

  if (lessonType === SCHOOLWIDE_TRAINING_LESSON_TYPE) {
    return (
      getRegistrationFromInstructorScope(instructorData, 'site')
        ?.registration_id ?? null
    )
  }

  if (isDwbTrainingCourseCode(courseCode)) {
    const educatorRegistration = findEducatorRegistrationByCourseCode(
      instructorData,
      courseCode,
    )
    if (educatorRegistration) {
      return educatorRegistration.registration_id ?? null
    }
  }

  if (isTrainingMarkCompleteContext(lessonType, courseCode)) {
    return (
      getRegistrationFromInstructorScope(instructorData, 'educator')
        ?.registration_id ?? null
    )
  }

  const normalizedCourseCode = String(courseCode || '').toLowerCase()
  const matchesCourseCode = registration =>
    matchesRegistrationCourseCode(registration, normalizedCourseCode)

  const siteEducatorRegistrations = Array.isArray(instructorData.siteEducator)
    ? instructorData.siteEducator
    : []
  const educatorRegistrations = Array.isArray(instructorData.educator)
    ? instructorData.educator
    : []

  const siteEducatorCourseMatch = siteEducatorRegistrations.find(
    matchesCourseCode,
  )
  const educatorCourseMatch = educatorRegistrations.find(matchesCourseCode)

  if (educatorCourseMatch && !siteEducatorCourseMatch) {
    return educatorCourseMatch.registration_id ?? null
  }

  if (!classId) return null
  const match = registrations.find(
    registration => String(registration.registration_id) === String(classId),
  )
  if (!match) {
    console.error(
      `[useMarkCompleteV3] no registration found for registration_id "${classId}" (instructorDataKey: "${instructorDataKey}")`,
    )
    return null
  }
  return match.registration_id ?? null
}
